import React from "react";
import styles from './Loading.module.scss';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

const Loading = () => {
  return (
    <div className={styles.container}>
      <LoadingOverlay />
    </div>
  );
};

export default Loading;